import React, { Children } from 'react';

type TapsTitlesType = {
  title: string;
};

const Tabs = ({
  tapsTitles,
  setActiveTabIndex,
  children,
  activeTabIndex,
}: {
  tapsTitles: TapsTitlesType[];
  setActiveTabIndex: React.Dispatch<React.SetStateAction<number>>;
  activeTabIndex: number;
  children?: React.ReactNode;
}) => {
  return (
    <>
      <div className="flex w-full justify-between text-center border-b border-gray">
        {tapsTitles.map((item, index) => (
          <div
            key={index}
            className="flex-1 flex justify-center flex-col items-center"
          >
            <button
              className={`w-full h-[40px]  px-4 py-2 ${activeTabIndex === index ? 'text-blue text-link' : 'text-gray__dark_1 text-body_2'}`}
              onClick={() => setActiveTabIndex(index)}
            >
              {item.title}
            </button>
            <div
              className={`w-full h-[3px] rounded-t-full !mt-[2px] ${activeTabIndex === index ? 'bg-blue' : 'bg-white'}`}
            ></div>
          </div>
        ))}
      </div>
      {Children.toArray(children)[activeTabIndex]}
    </>
  );
};

export default Tabs;
